import { type ComponentProps, type MouseEventHandler, type ReactNode, useState } from 'react'
import { InfoIcon } from '../../icons/InfoIcon'
import { IconButton } from '../Button/IconButton'
import { Tooltip } from './Tooltip'
import { tokens } from '../../theme/tokens.css'

type Props = {
  Trigger?: NonNullable<ReactNode>
} & Omit<ComponentProps<typeof Tooltip.Content>, 'onEscapeKeyDown' | 'onPointerDownOutside'>

const DEFAULT_TRIGGER = (
  <IconButton data-no-hover Icon={<InfoIcon size="1rem" color={tokens.colors.fills.opaque.secondary} />} />
)

export function ToggleTip({ children, Trigger = DEFAULT_TRIGGER, ...forwardedProps }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation()
    setIsOpen(true)
  }

  const close = () => setIsOpen(false)

  return (
    <Tooltip.Root open={isOpen}>
      <Tooltip.Trigger asChild={true} onClick={handleClick} type="button">
        {Trigger}
      </Tooltip.Trigger>
      <Tooltip.Content
        onEscapeKeyDown={close}
        onPointerDownOutside={close}
        arrow={true}
        collisionPadding={8}
        sideOffset={4}
        {...forwardedProps}
      >
        {children}
      </Tooltip.Content>
    </Tooltip.Root>
  )
}
